module.exports = function forEach(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(i, arr[i]);
  }
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/chickencurry/lib/forEach.js
// module id = JIb5
// module chunks = 0